import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { portalApi, setPortalToken, getPortalToken, getPortalView } from "@/lib/portalApi";

const PortalAuthContext = createContext(null);
export const usePortalAuth = () => useContext(PortalAuthContext);

export function PortalAuthProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    // A Portal View session (admin) OR a real client login both resolve via /portal/me.
    if (!getPortalView() && !getPortalToken()) { setLoading(false); return; }
    try {
      const { data } = await portalApi.get("/portal/me");
      setProfile(data);
    } catch {
      setPortalToken(null);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await portalApi.post("/portal/auth/login", { email, password });
    setPortalToken(data.token);
    setProfile(data.profile);
    return data;
  };

  const activate = async (token, password, source) => {
    const { data } = await portalApi.post("/portal/auth/activate", { token, password, source });
    setPortalToken(data.token);
    setProfile(data.profile);
    return data;
  };

  const logout = () => { setPortalToken(null); setProfile(null); };

  const can = (perm) => (profile?.permissions || []).includes(perm);

  return (
    <PortalAuthContext.Provider value={{ profile, setProfile, loading, login, activate, logout, refresh: fetchMe, can }}>
      {children}
    </PortalAuthContext.Provider>
  );
}
